import * as React from "react";
import { connect } from "react-redux";

import styles from "./requestViewPLGR.module.scss";
import { IUseCase } from "../../../../../interfaces/IUseCase";
import Download from "../../../atoms/downloadButton/download";
import { useEffect, useState } from "react";
import { BlobServiceClient } from "@azure/storage-blob";

interface FileListProps {
  url: string;
}

function RequestViewPLGR(props: any) {
  const containerName = "requestfiles";
  const accountName = "requestpoint";
  const sasToken =
    "?sv=2021-12-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2023-12-31T23:37:22Z&st=2023-04-18T14:37:22Z&spr=https&sig=kk7j1tFdRCxNp5MZAJhH2kn9JNajJpzhyrKve5DD%2B08%3D";

  const [files, setFiles] = useState<string[]>([]);

  const [directory, setDirectory] = useState(
    `${props.currentRequestObject.idStakeholdersNavigation.requestingPerson}/${props.currentRequestObject.requestLabel}/`
  );

  useEffect(() => {
    const listFiles = async () => {
      try {
        const blobServiceClient = new BlobServiceClient(
          `https://${accountName}.blob.core.windows.net${sasToken}`
        );
        const containerClient =
          blobServiceClient.getContainerClient(containerName);
        const response = containerClient.listBlobsFlat({ prefix: directory });
        console.log(directory);
        const fileList = [];
        for await (const blob of response) {
          fileList.push(blob.name);
        }
        setFiles(fileList);
        console.log(`filelist: ${fileList}`);
        if (fileList.length === 0) {
          setDirectory(
            `${props.currentRequestObject.idStakeholdersNavigation.requestingPerson}/${props.currentRequestObject.requestLabel}/`
          );
          console.log("fileList.length === 0");
          const blobServiceClient = new BlobServiceClient(
            `https://${accountName}.blob.core.windows.net${sasToken}`
          );
          const containerClient =
            blobServiceClient.getContainerClient(containerName);
          const response = containerClient.listBlobsFlat({ prefix: directory });
          console.log(directory);
          const fileList = [];
          for await (const blob of response) {
            fileList.push(blob.name);
          }
          setFiles(fileList);
          console.log(`filelist: ${fileList}`);
        }
      } catch (error) {
        console.error(error);
      }
    };

    listFiles();
  }, [
    accountName,
    sasToken,
    props.containerName,
    directory,
    props.currentRequestObject,
  ]);

  return (
    <>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />
        <div className={styles.sectionContainer__window}>
          <h3>Use Cases</h3>
          <div className={styles.useCasesSummary__tableContainer}>
            <div className={styles.useCasesSummary__tableHeader}>
              <div>
                <p>Description</p>
              </div>
              <div>
                <p>Pre-conditions</p>
              </div>
              <div>
                <p>Post-conditions</p>
              </div>
            </div>
            {props.currentRequestObject.idContentNavigation.idPlgrNavigation
              .useCases.length > 0 ? (
              props.currentRequestObject.idContentNavigation.idPlgrNavigation.useCases.map(
                (useCase: IUseCase) => (
                  <div
                    className={
                      useCase ===
                      props.currentRequestObject.idContentNavigation.idPlgrNavigation.useCases.slice(
                        -1
                      )[0]
                        ? styles.useCasesSummary__tableRow__last
                        : styles.useCasesSummary__tableRow
                    }
                  >
                    <div>
                      <p>{useCase.description}</p>
                    </div>
                    <div>
                      <p>{useCase.preConditions}</p>
                    </div>
                    <div>
                      <p>{useCase.postConditions}</p>
                    </div>
                  </div>
                )
              )
            ) : (
              <div className={styles.emptyTable}>
                <p>Empty</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />
        <div className={styles.sectionContainer__window}>
          <h3>Functions and Context</h3>
          <div className={styles.sectionContainer__window__contentContainer}>
            <h4>Functions and features</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idFunctionsAndContextNavigation.functionsFeatures.length >
              0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idFunctionsAndContextNavigation.functionsFeatures
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Solution context</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idFunctionsAndContextNavigation.solutionContext.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idFunctionsAndContextNavigation.solutionContext
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Supported environment</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idFunctionsAndContextNavigation.supportedPlenv.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idFunctionsAndContextNavigation.supportedPlenv
              ) : (
                <>Empty</>
              )}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />
        <div className={styles.sectionContainer__window}>
          <h3>User Interface</h3>
          <div className={styles.sectionContainer__window__contentContainer}>
            <h4>UI description</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idUserInterfaceNavigation.uidescription.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idUserInterfaceNavigation.uidescription
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>UI Files:</h4>
            {files.filter((str) => str.includes("ui")).length > 0 ? (
              files
                .filter((str) => str.includes("ui"))
                .map((filePath) => <Download filePath={filePath} />)
            ) : (
              <p>No files attached</p>
            )}
          </div>
        </div>
      </div>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />
        <div className={styles.sectionContainer__window}>
          <h3>Reports</h3>
          <div className={styles.sectionContainer__window__contentContainer}>
            <h4>Reports description</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idReportsNavigation.reportsDescription.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idReportsNavigation.reportsDescription
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Reports Files:</h4>
            {files.filter((str) => str.includes("rep")).length > 0 ? (
              files
                .filter((str) => str.includes("rep"))
                .map((filePath) => <Download filePath={filePath} />)
            ) : (
              <p>No files attached</p>
            )}
          </div>
        </div>
      </div>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />

        <div className={styles.sectionContainer__window}>
          <h3>Acceptance Criteria</h3>
          <div className={styles.sectionContainer__window__contentContainer}>
            <h4>Acceptance criteria description</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idAcceptanceCriteriaNavigation.acceptanceCriteriaDescription
                .length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idAcceptanceCriteriaNavigation.acceptanceCriteriaDescription
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Test protocol documents:</h4>
            {files.filter((str) => str.includes("tespro")).length > 0 ? (
              files
                .filter((str) => str.includes("tespro"))
                .map((filePath) => <Download filePath={filePath} />)
            ) : (
              <p>No files attached</p>
            )}
          </div>
        </div>
      </div>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContainer__sideBar} />

        <div className={styles.sectionContainer__window}>
          <h3>Other</h3>
          <div className={styles.sectionContainer__window__contentContainer}>
            <h4>Out of scope</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idOtherNavigation.outOfScope.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idOtherNavigation.outOfScope
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Revenat decisions</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idOtherNavigation.revenatDecisionsn.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idOtherNavigation.revenatDecisionsn
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Document references: </h4>
            {files.filter((str) => str.includes("docref")).length > 0 ? (
              files
                .filter((str) => str.includes("docref"))
                .map((filePath) => <Download filePath={filePath} />)
            ) : (
              <p>No files attached</p>
            )}
            <h4>Non-functional requirements</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idOtherNavigation.nonFunctionalRequirements.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idOtherNavigation.nonFunctionalRequirements
              ) : (
                <>Empty</>
              )}
            </p>
            <h4>Assumptions made</h4>
            <p>
              {props.currentRequestObject.idContentNavigation.idPlgrNavigation
                .idOtherNavigation.assumptionsMade.length > 0 ? (
                props.currentRequestObject.idContentNavigation.idPlgrNavigation
                  .idOtherNavigation.assumptionsMade
              ) : (
                <>Empty</>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps: any = (state: any) => {
  return {
    currentRequestObject: state.currentRequestObject,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestViewPLGR);
